module.exports = __webpack_public_path__ + "static/media/imagenotavailable.4ea3f987.png";